const formatAtheneumContact = email => {
  const name = email.emailAddress.name.split('@')[0].replace('.', ' ').split(' ').map(name => name.charAt(0).toUpperCase() + name.slice(1)).join(' ');
  return {
    fullName: name,
    email: email.emailAddress.address
  };
};

export default formatAtheneumContact;